import template from "./verpackung-copy-btn.html.twig";

Packlab.Component.register('verpackung-copy-btn', {
    template,

    inject: [ 'verpackungService', 'apiClient' ],

    props: {
        verpackungId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            isLoading: false,
            isCopying: false,
            showModal: false,
            verpackung: null
        }
    },

    methods: {
        onOpenModal() {
            if(this.verpackung) {
               this.showModal = true;
            } else {
                this.isLoading = true;
                this.verpackungService.loadVerpackung(this.verpackungId, false)
                    .then((result) => {
                        this.verpackung = result.verpackungTyp.getVerpackungById(this.verpackungId);
                        this.showModal = true;
                        this.isLoading = false;
                    })
                    .catch(() => {
                        this.isLoading = false;
                    });
            }
        },
        onHideModal() {
            this.showModal = false;
        },
        copyVerpackung() {
            this.isCopying = true;
            this.apiClient.copyVerpackung(this.verpackungId)
                .then((result) => {
                    this.isCopying = false;
                    this.$refs.modal.hide();
                    this.$router.push(`/verpackung/${result.verpackung.id}/edit`);
                })
                .catch(() => { this.isCopying = false; });
        }
    }
});